import { createRouter, createWebHistory } from 'vue-router';
import Test from '../components/Test.vue';
import Stats from '../components/Stats.vue';

const routes = [
	{
		path: '/',
		component: Test,
	},
	{
		path: '/stats/',
		component: Stats,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	base: '/js_files/vue/frontend_quiz',
});

export default router;
